export interface VideoItem {
  id: number;
  title: string;
  category: string;
  duration: string;
  views: string;
  likes: string;
  year: string;
  tags: string[];
  cover: string;
  summary: string;
  hot?: boolean;
}

export const videoCategories = [
  "全部",
  "娱乐综艺",
  "明星八卦",
  "热剧剪辑",
  "搞笑日常",
  "社会热点",
  "生活妙招",
];

export const videos: VideoItem[] = [
  {
    id: 1,
    title: "综艺名场面：本期游戏环节全员笑到岔气",
    category: "娱乐综艺",
    duration: "08:32",
    views: "128.6万",
    likes: "4.2万",
    year: "2026",
    tags: ["综艺", "名场面", "爆笑"],
    cover: "https://readdy.ai/api/search-image?query=Bright%20fun%20game%20show%20studio%20stage%20with%20colorful%20spotlights%20and%20confetti%2C%20energetic%20entertainment%20atmosphere%2C%20flat%20illustration%20style%2C%20warm%20coral%20and%20amber%20tones%2C%20clean%20composition&width=640&height=360&seq=video-01&orientation=landscape",
    summary: "本期的游戏环节反转不断，几位嘉宾的临场发挥让现场气氛直接拉满，弹幕全程刷屏。",
    hot: true,
  },
  {
    id: 2,
    title: "热剧大结局解析：这条伏笔原来埋了三季",
    category: "热剧剪辑",
    duration: "12:05",
    views: "96.3万",
    likes: "3.1万",
    year: "2026",
    tags: ["热剧", "解析", "结局"],
    cover: "https://readdy.ai/api/search-image?query=Dramatic%20dark%20cinematic%20television%20studio%20scene%20with%20dramatic%20warm%20lighting%20and%20film%20clapperboard%2C%20moody%20atmosphere%2C%20modern%20illustration%2C%20coral%20and%20charcoal%20tones&width=640&height=360&seq=video-02&orientation=landscape",
    summary: "编剧早在第一季就埋下的伏笔，直到大结局才回收。这期视频帮你把时间线完整捋清。",
    hot: true,
  },
  {
    id: 3,
    title: "明星访谈全程高能：聊到旧照当场社死",
    category: "明星八卦",
    duration: "15:48",
    views: "205.7万",
    likes: "6.8万",
    year: "2026",
    tags: ["访谈", "八卦", "名场面"],
    cover: "https://readdy.ai/api/search-image?query=Cozy%20sofa%20interview%20studio%20with%20soft%20warm%20lights%20and%20microphones%2C%20friendly%20conversation%20vibe%2C%20flat%20illustration%2C%20warm%20neutral%20cream%20background&width=640&height=360&seq=video-03&orientation=landscape",
    summary: "访谈进行到一半，主持人突然掏出嘉宾学生时代的旧照片，现场气氛瞬间白热化。",
    hot: true,
  },
  {
    id: 4,
    title: "上班族的自我修养：下班后这三件事最解压",
    category: "生活妙招",
    duration: "06:14",
    views: "42.9万",
    likes: "1.6万",
    year: "2026",
    tags: ["生活", "解压", "妙招"],
    cover: "https://readdy.ai/api/search-image?query=Relaxing%20evening%20home%20scene%20with%20warm%20lamp%20light%20cup%20of%20tea%20and%20cozy%20plants%2C%20calm%20lifestyle%20illustration%2C%20soft%20cream%20and%20green%20tones&width=640&height=360&seq=video-04&orientation=landscape",
    summary: "下班之后怎么真正放松？三个小习惯帮你把白天的疲惫一键清空。",
  },
  {
    id: 5,
    title: "搞笑宠物合集：这只猫的戏比我还多",
    category: "搞笑日常",
    duration: "04:27",
    views: "310.2万",
    likes: "11.5万",
    year: "2026",
    tags: ["宠物", "搞笑", "猫"],
    cover: "https://readdy.ai/api/search-image?query=Playful%20orange%20cat%20playing%20with%20yarn%20in%20sunny%20living%20room%2C%20cute%20flat%20illustration%20style%2C%20bright%20and%20cheerful%2C%20cream%20background%20with%20green%20accents&width=640&height=360&seq=video-05&orientation=landscape",
    summary: "高冷猫主子在线整活，各种迷惑行为连铲屎官都看呆了。",
    hot: true,
  },
  {
    id: 6,
    title: "社会热点追踪：这座小城为何突然走红",
    category: "社会热点",
    duration: "09:56",
    views: "78.4万",
    likes: "2.3万",
    year: "2026",
    tags: ["热点", "追踪", "旅游"],
    cover: "https://readdy.ai/api/search-image?query=Charming%20small%20town%20street%20with%20warm%20evening%20lights%20and%20food%20stalls%2C%20lively%20travel%20illustration%2C%20warm%20orange%20and%20cream%20tones&width=640&height=360&seq=video-06&orientation=landscape",
    summary: "一座原本安静的小城，因为短视频一夜走红。我们实地探访，聊聊走红背后的真实故事。",
  },
  {
    id: 7,
    title: "综艺收官特辑：嘉宾集体泪洒现场",
    category: "娱乐综艺",
    duration: "18:22",
    views: "143.5万",
    likes: "5.0万",
    year: "2026",
    tags: ["综艺", "收官", "感动"],
    cover: "https://readdy.ai/api/search-image?query=Emotional%20variety%20show%20stage%20with%20warm%20golden%20lights%20and%20flowers%2C%20heartfelt%20ending%20scene%2C%20flat%20illustration%2C%20warm%20coral%20and%20amber%20tones&width=640&height=360&seq=video-07&orientation=landscape",
    summary: "历时三个月的节目迎来收官，嘉宾们回顾一路走来的点滴，现场几度哽咽。",
  },
  {
    id: 8,
    title: "热剧穿帮镜头盘点：道具师这波太真实了",
    category: "热剧剪辑",
    duration: "05:39",
    views: "67.8万",
    likes: "2.0万",
    year: "2026",
    tags: ["热剧", "穿帮", "盘点"],
    cover: "https://readdy.ai/api/search-image?query=Funny%20film%20set%20scene%20with%20clapperboard%20and%20miscellaneous%20film%20props%2C%20playful%20illustration%2C%20bright%20warm%20colors%2C%20clean%20composition&width=640&height=360&seq=video-08&orientation=landscape",
    summary: "追剧也能当侦探！这些藏在镜头角落的穿帮细节，你发现了几个？",
  },
  {
    id: 9,
    title: "明星同款穿搭拆解：平价也能穿出高级感",
    category: "明星八卦",
    duration: "07:41",
    views: "52.6万",
    likes: "1.8万",
    year: "2026",
    tags: ["穿搭", "明星", "时尚"],
    cover: "https://readdy.ai/api/search-image?query=Fashionable%20clothing%20rack%20with%20colorful%20outfits%20and%20accessories%2C%20style%20flat%20illustration%2C%20warm%20cream%20background%20with%20green%20and%20coral%20accents&width=640&height=360&seq=video-09&orientation=landscape",
    summary: "不追大牌也能穿出明星同款气场，本期的平价穿搭公式记得收藏。",
  },
  {
    id: 10,
    title: "厨房小白友好：三分钟学会这道拿手菜",
    category: "生活妙招",
    duration: "03:58",
    views: "89.1万",
    likes: "3.4万",
    year: "2026",
    tags: ["美食", "料理", "厨房"],
    cover: "https://readdy.ai/api/search-image?query=Delicious%20home%20cooked%20dish%20on%20wooden%20table%20with%20fresh%20vegetables%2C%20appetizing%20food%20illustration%2C%20warm%20natural%20lighting%2C%20clean%20composition&width=640&height=360&seq=video-10&orientation=landscape",
    summary: "零基础也能轻松上手的家常菜，跟着步骤做，翻车率极低。",
  },
  {
    id: 11,
    title: "全网都在找的这段舞蹈，完整版在这里",
    category: "搞笑日常",
    duration: "02:46",
    views: "156.9万",
    likes: "7.7万",
    year: "2026",
    tags: ["舞蹈", "热门", "挑战"],
    cover: "https://readdy.ai/api/search-image?query=People%20dancing%20energetically%20in%20a%20bright%20urban%20plaza%20at%20dusk%2C%20vibrant%20motion%20illustration%2C%20warm%20orange%20and%20cream%20tones&width=640&height=360&seq=video-11&orientation=landscape",
    summary: "近期刷屏的这段魔性舞蹈完整版来啦，节奏感直接拉满，看完就忍不住跟着动。",
    hot: true,
  },
  {
    id: 12,
    title: "老照片修复师的一天：让记忆重新鲜活",
    category: "社会热点",
    duration: "10:33",
    views: "34.7万",
    likes: "1.2万",
    year: "2026",
    tags: ["人物", "匠心", "温暖"],
    cover: "https://readdy.ai/api/search-image?query=Vintage%20photographs%20and%20photo%20restoration%20desk%20with%20warm%20desk%20lamp%2C%20nostalgic%20workshop%20illustration%2C%20warm%20cream%20and%20brown%20tones&width=640&height=360&seq=video-12&orientation=landscape",
    summary: "一张模糊的老照片，在他手中重新变得清晰。听听这位修复师与记忆的故事。",
  },
];